import React, { useState }from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { resetPagination } from 'reducers/paginationReceivedEmailsSlice';
import { setFilters, resetFilters } from 'reducers/filtersReceivedEmailsSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Messages from 'pages/messages/Messages';
import Person from 'pages/main/Person';
import ReceivedEmailList from 'pages/recievedemails/ReceivedEmailList';
 
const HomeReceivedEmail = () => {
    const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
    const dispatch = useDispatch();
    const filtersReceivedEmailsDetails = useSelector((state) => state.filtersReceivedEmails); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalReceivedEmails, setShowModalReceivedEmails] = useState(true); 

    const scriptUrl = '/js/sb-admin-2.min.js'; 

    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ reasonFromES: "", reasonToES: "",statusFromES: "", statusToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ reasonFromEN: "", reasonToEN: "",statusFromEN: "", statusToEN: "" }));
        }
    };

    const closeModalRegisterBook = () => {    
        dispatch(resetPagination());
        dispatch(resetFilters());
        setShowModalReceivedEmails(false);
        return () => {};
    }; 

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/receivedemails">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersReceivedEmailsDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersReceivedEmailsDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersReceivedEmailsDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.idFrom}
                    </li>
                    <div className={filtersReceivedEmailsDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('PlaceHolder_Filter_Code_to')}
                    </div>
                    <li className={filtersReceivedEmailsDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersReceivedEmailsDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.idTo}
                    </li>
                    
                    {roles[0].listmenus.find((key)=>(key.name==="View_EMAILS_ALL_STORES"))&&
                        <>
                            <div className={filtersReceivedEmailsDetails.defaultStoreIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_From')}
                            </div>
                            <li className={filtersReceivedEmailsDetails.defaultStoreIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersReceivedEmailsDetails.defaultStoreIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.defaultStoreIdFrom}
                            </li>
                            <div className={filtersReceivedEmailsDetails.defaultStoreIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_To')}
                            </div>
                            <li className={filtersReceivedEmailsDetails.defaultStoreIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersReceivedEmailsDetails.defaultStoreIdTo==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.defaultStoreIdTo}
                            </li>
                        </>
                    }
                    
 
                    <div className={filtersReceivedEmailsDetails.dateEmailFrom===null || filtersReceivedEmailsDetails.dateEmailFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Date_From')}
                    </div>
                    <li className={filtersReceivedEmailsDetails.dateEmailFrom===null || filtersReceivedEmailsDetails.dateEmailFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        {filtersReceivedEmailsDetails.dateEmailFrom===null || filtersReceivedEmailsDetails.dateEmailFrom===''? t('Text_Filter_Not_Apply'): new Date(filtersReceivedEmailsDetails.dateEmailFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
                    <div className={filtersReceivedEmailsDetails.dateEmailTo===null || filtersReceivedEmailsDetails.dateEmailTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Date_To')}
                    </div>
                    <li className={filtersReceivedEmailsDetails.dateEmailTo===null || filtersReceivedEmailsDetails.dateEmailTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersReceivedEmailsDetails.dateEmailTo===null || filtersReceivedEmailsDetails.dateEmailTo===''? t('Text_Filter_Not_Apply'):new Date(filtersReceivedEmailsDetails.dateEmailTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
 
                    <div className={(filtersReceivedEmailsDetails.statusFromEN==='' && filtersReceivedEmailsDetails.statusFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Status_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersReceivedEmailsDetails.statusFromEN==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.statusFromEN:filtersReceivedEmailsDetails.statusFromES==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.statusFromES}
                    </li>
                    <div className={(filtersReceivedEmailsDetails.statusToEN==='' && filtersReceivedEmailsDetails.statusToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Status_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersReceivedEmailsDetails.statusToEN==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.statusToEN:filtersReceivedEmailsDetails.statusToES==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.statusToES}
                    </li>    

                    <div className={(filtersReceivedEmailsDetails.reasonFromEN==='' && filtersReceivedEmailsDetails.reasonFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Reason_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersReceivedEmailsDetails.reasonFromEN==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.reasonFromEN:filtersReceivedEmailsDetails.reasonFromES==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.reasonFromES}
                    </li>
                    <div className={(filtersReceivedEmailsDetails.reasonToEN==='' && filtersReceivedEmailsDetails.reasonToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Reason_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersReceivedEmailsDetails.reasonToEN==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.reasonToEN:filtersReceivedEmailsDetails.reasonToES==='' ? t('Text_Filter_Not_Apply'): filtersReceivedEmailsDetails.reasonToES}
                    </li>    
                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/receivedemails" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                   <Link className="collapse-item" to="/receivedemails" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalRegisterBook} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <ReceivedEmailList  
                    showModalReceivedEmails={showModalReceivedEmails}
                    setShowModalReceivedEmails={setShowModalReceivedEmails}
                />
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeReceivedEmail;
